/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class ShellGlobalTextKey {
  static readonly VENDOR = 'shell/global/vendor';
  static readonly VENDOR_SOFTWARE = 'shell/global/vendor-software';
}
